import styled from 'styled-components'

export const Style = styled.div`
  margin-top: 55px;
  .border {
    display: flex;
    justify-content: center;
  }
  @media screen and (min-width: 300px) and (max-width: 1116px) {
    margin-top: 0;
    .card-long-box {
      padding: 16px;
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      align-items: center;
    }
    .card-long-image {
      width: 80px;
      height: 80px;
    }
    .text {
      width: calc(100% - 100px);
      .title {
      }
    }
    h4,
    p {
      text-align: left !important;
    }
    h4 {
      font-size: 16px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #555555;
    }
    p {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #888888;
    }
    .title-one {
      text-align: left;
    }
    .title-body-one {
      text-align: left;
    }
    .border {
      display: flex;
      justify-content: flex-start;
    }
  }
  .column-bottom {
    margin-bottom: 24px;
  }
  .bottom-column {
    margin-bottom: 20px;
  }
`
